import { captureException } from '@sentry/react';
import { GroupId } from '@sr/types';
import useStore from 'store';
import { ArrowLeftIcon, ArrowRightIcon, Box } from 'v1/ui';

export default function GroupControls({
  groupId,
  numMessages,
}: {
  groupId: GroupId;
  numMessages: number;
}) {
  const index = useStore.useActiveGroupMessageIndex();
  const nextMessage = useStore.useNextMessage();
  const previousMessage = useStore.usePreviousMessage();

  if (index === null) {
    captureException(
      new Error('store.activeGroupMessageIndex cannot be null'),
      {
        tags: { noFeedback: true },
      }
    );
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgba(228, 235, 241, 1)',
        pb: '9px',
        mb: 4,
      }}
    >
      <ArrowLeftIcon
        color="black60"
        onClick={previousMessage}
        sx={{ strokeWidth: 2, cursor: 'pointer', userSelect: 'none' }}
      />
      <Box sx={{ color: 'black60', fontSize: 18, fontWeight: 600 }}>
        {index + 1}/{numMessages}
      </Box>
      <ArrowRightIcon
        color="black60"
        onClick={nextMessage}
        sx={{ strokeWidth: 2, cursor: 'pointer', userSelect: 'none' }}
      />
    </Box>
  );
}
